export const AD_HOC_OPTION_VALUE = 'ad-hoc';
export var ContactAgreementState = /*#__PURE__*/ function(ContactAgreementState) {
    ContactAgreementState["OnlySignedAgreements"] = "onlySignedAgreements";
    ContactAgreementState["NoSignedAgreement"] = "noSignedAgreement";
    ContactAgreementState["SignedAndAdHoc"] = "signedAndAdHoc";
    return ContactAgreementState;
}({});
export const classifyContactAgreementState = (agreements, adHocSummary)=>{
    if (agreements.length === 0) {
        return "noSignedAgreement";
    }
    if (adHocSummary == null) {
        return "onlySignedAgreements";
    }
    return "signedAndAdHoc";
};
export const getServiceOptionSelected = (option, value)=>option.id === value.id;
export const getServiceOptionLabel = (option)=>option.name;
